import { createStore } from 'vuex'
import mutations from './mutations'
import getters from './getters'
import persistedState from 'vuex-persistedstate'
import SecureLS from 'secure-ls'
var ls = new SecureLS({ isCompression: false })
export default createStore({
  state: {
    token:{
      accessToken: '',
      expireTime:0,
      refreshToken:'',
    }, 
    adminInfo:{}  as any,
    systemConfig:{} as any,
    activeMenu: [],
    systemSet: {
      activeTheme: '',
      tabFalg: true,
      logoFalg: true,
      btnAuth:false
    }
  },
  mutations,
  actions: {
  },
  getters,
  plugins: [
    persistedState({
      storage: {
        setItem: (key, value) => ls.set(key, value),
        getItem: (key) => ls.get(key),
        removeItem: (key) => ls.remove(key)
      }
    })
  ]
})
